import React from 'react';

import { useTranslation } from "react-i18next";

import i1 from '../../img/News/i1.png'
import i2 from '../../img/News/i2.png'
import i3 from '../../img/News/i3.png'
import i4 from '../../img/News/i4.png'

function Innovative () {
      
    const { t } = useTranslation();

    return(
        <div className="overflow-hidden relative max-w-[1220px] mx-[20px] md:mx-[40px] xl:mx-auto pt-[100px] xl:pt-[140px]">
           <div className='flex flex-col xl:flex-row justify-between'>
                <div className='flex flex-col'>
                    <p className='text-[28px] xl:text-[45px] open-sans leading-[1.4] text-[#F26522] xl:max-w-[415px]'>{t('news.18')}</p>
                    <p className='hidden xl:block mt-[15px] text-[14px] font-[300] text-white open-sans xl:max-w-[485px]'>{t('news.19')}</p>
                    <p className='hidden xl:block mt-[40px] px-[32px] py-[10px] mr-auto bg-[#F26522] open-sans text-[16px] font-[600] rounded-[5px] text-[#1D1D1D]'>{t('news.17')}</p>
                </div>
                <div className='flex flex-col gap-[19px] mt-[30px] xl:mt-0'>
                    <div className='flex gap-[19px]'>
                        <img src={i1} alt="" className='w-1/2 xl:w-auto'/>
                        <img src={i2} alt="" className='w-1/2 xl:w-auto'/>
                    </div>
                    <div className='flex gap-[19px]'>
                        <img src={i3} alt="" className='w-1/2 xl:w-auto'/>
                        <img src={i4} alt="" className='w-1/2 xl:w-auto'/>
                    </div>
                </div>
                <p className='xl:hidden block mt-[15px] text-[14px] font-[300] text-white open-sans xl:max-w-[485px]'>{t('news.19')}</p>
                <p className='xl:hidden block mt-[40px] px-[32px] py-[10px] mr-auto bg-[#F26522] open-sans text-[16px] font-[600] rounded-[5px] text-[#1D1D1D]'>{t('news.17')}</p> 
           </div>
        </div>
    );
}

export default Innovative;